<template>
  <nav class="navbar mobile-navbar" :style="navbarStyles">
    <div class="navbar-content">
      <div class="logo">
        <router-link to="/">
          <img src="/TWConnLogo.png" alt="台灣聯通" />
        </router-link>
      </div>

      <!-- Grouping Login Button and Hamburger Menu -->
      <div class="mobile-controls">
        <!-- Login/Logout Button for Mobile -->
        <div v-if="user">
          <router-link to="/" class="btn-login" @click="attemptLogout">
            {{ user }} 登出
          </router-link>
        </div>
        <div v-else>
          <router-link to="/login-page" class="btn-login">
            登入
          </router-link>
        </div>

        <!-- Hamburger Menu -->
        <div :class="['hamburger-menu', { 'is-active': isMobileMenuOpen }]" @click="toggleMobileMenu" role="button"
          aria-label="Toggle navigation menu" :aria-expanded="isMobileMenuOpen">
          <span></span>
          <!-- <span></span> -->
          <span></span> <!-- Added third span for better hamburger animation -->
        </div>
      </div>
      <!-- End of Grouping -->
    </div>

    <!-- Navigation Links -->
    <div class="nav-links" :class="{ 'mobile-active': isMobileMenuOpen }">
      <ul>
        <li>
          <router-link to="/about">公司簡介</router-link>
        </li>

        <li>
          <router-link to="/parking-lots">停車場位置</router-link>
        </li>

        <li>
          <router-link to="/offer-cards">信用卡優惠</router-link>
        </li>
        <li>
          <router-link to="/collaboration-page">委託與合作</router-link>
        </li>
        <li>
          <router-link to="/parking-sale">出售車位</router-link>
        </li>
        <li>
          <router-link to="/quick-pass">快速通</router-link>
        </li>

        <li>
          <span :class="['disabled-link toggle-dropdown', { 'active': dropdownVisible }]" @click="toggleDropdown">
            月票與會員
            <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" fill="none"
              aria-hidden="true">
              <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <ul v-if="dropdownVisible" class="dropdown2">
            <li v-if="!user">
              <router-link to="/UserRegister">會員註冊</router-link>
            </li>

            <li>
              <router-link to="/UserApply">月票申辦</router-link>
            </li>
            <li>
              <router-link to="/UserRecord">月票登記抽籤</router-link>
            </li>
            <li>
              <router-link to="/UserCancel">退租登記</router-link>
            </li>
            <li v-if="user">
              <router-link v-if="user" to="/month-ticket-bill">月票繳費</router-link>
            </li>
            <li v-if="user">
              <router-link v-if="user" to="/lpboard">會員車號登記</router-link>
            </li>
          </ul>
        </li>



        <li v-if="user">
          <span :class="['disabled-link toggle-dropdown', { 'active': dropdown2Visible }]" @click="toggleDropdown2">
            臨停線上繳費
            <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" fill="none"
              aria-hidden="true">
              <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <ul v-if="dropdown2Visible" class="dropdown2">
            <li>
              <router-link to="/OnlinePayment">臨停線上繳費</router-link>
            </li>
            <li v-if="user">
              <router-link to="/cardboard">紅利折抵卡片登記</router-link>
            </li>
          </ul>
        </li>
        <li v-if="!user">
          <router-link to="/OnlinePayment">臨停線上繳費</router-link>
        </li>
        <li>
          <router-link to="/recruitment-page">人才招募</router-link>
        </li>
        <li>
          <span :class="['disabled-link toggle-dropdown', { 'active': dropdown3Visible }]" @click="toggleDropdown3">
            宜蘭路邊停車
            <svg class="chevron-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" fill="none"
              aria-hidden="true">
              <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <ul v-if="dropdown3Visible" class="dropdown2">
            <li>
              <router-link to="/disability-parking" @click="closeMenu">身障優惠登記</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!-- End of Navigation Links -->
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MobileNavbar',
  data() {
    return {
      dropdownVisible: false,
      dropdown2Visible: false,
      dropdown3Visible: false,
      isMobileMenuOpen: false,
    };
  },
  computed: {
    ...mapGetters(['user']),

    // Single computed property for width
    dynamicWidth() {
      return this.$route.path === '/' ? '92vw' : '99.9%';
    },

    navbarStyles() {
      const isHomePage = this.$route.path === '/';
      return {
        width: this.dynamicWidth,
        marginTop: isHomePage ? '10px' : '0',

        left: '50%',
        transform: 'translateX(-50%)',
      };
    },
  },
  methods: {
    ...mapActions(['logout']),
    async attemptLogout() {
      try {
        await this.logout();
        console.log('登出成功');
        this.$router.push('/');
      } catch (error) {
        console.error('登出失敗:', error);
      }
    },
    toggleDropdown2() {
      this.dropdown2Visible = !this.dropdown2Visible;
    },
    toggleDropdown3() {
      this.dropdown3Visible = !this.dropdown3Visible;
    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    // 外部連結不會觸發路由變化，需自行收起選單
    closeMenu() {
      this.isMobileMenuOpen = false;
      this.dropdownVisible = false;
      this.dropdown2Visible = false;
      this.dropdown3Visible = false;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      if (!this.isMobileMenuOpen) {
        this.dropdownVisible = false;
        this.dropdown3Visible = false;
      }
    },
  },
  watch: {
    $route() {
      this.isMobileMenuOpen = false;
      this.dropdownVisible = false;
    },
  },
};
</script>

<style scoped>
.navbar {
  display: flex;

  justify-content: center;
  padding: 0;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  top: 0;
  z-index: 500;

  width: 100%;
  height: 56px;
  border: 1px solid #f1f1f1;
  position: absolute;
  box-sizing: border-box;
  border-radius: 8px;
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  position: relative;
  /* To contain absolutely positioned nav-links */
}

.logo img {
  height: 32px;
  margin-top: 7.5px;
}

.mobile-controls {
  display: flex;

  align-items: center;
  gap: 12px;
  /* Added some gap for better spacing */
}

.btn-login {
  background-color: var(--green03);
  color: white !important;
  padding: 8px 16px;
  border-radius: 25px;
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  margin-right: 0;
  /* Removed redundant margins */
  margin-left: 0;
}

.hamburger-menu {
  display: flex;
  flex-direction: column;
  gap: 5.5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.hamburger-menu span {
  width: 18px;
  height: 2.5px;
  background-color: var(--green03);
  transition: all 0.3s ease;
}

/* Hamburger Menu Animation */
.hamburger-menu.is-active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-menu.is-active span:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.is-active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* Navigation Links Styles */
.nav-links {
  /* Reset list styles */
  list-style: none;
  padding: 0;
  margin: 0;

  /* Hide by default */
  display: none;

  /* Flex container for vertical alignment */
  flex-direction: column;
  align-items: flex-start;
  /* Align items to the left */

  /* Positioning */
  position: absolute;
  top: 64px;
  /* Align below the navbar */
  left: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
  width: 100%;
}

.nav-links.mobile-active {
  display: flex;
}

.nav-links ul {
  list-style: none;
  /* Remove bullets */
  padding: 0;
  margin: 0;
  width: 100%;
}

.nav-links li {
  /* Remove any left margin to align items to the left */
  margin: 0;
  padding: 10px 20px;
  text-align: left;
}

.nav-links a,
.disabled-link {
  text-decoration: none;
  color: var(--green03);
  font-size: 16px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: bold;
  white-space: nowrap;
}

.disabled-link {
  cursor: pointer;
  /* Changed to pointer to indicate interactivity */
  user-select: none;
  display: flex;
  align-items: center;
  /* To align chevron vertically */
}

.toggle-dropdown.active .chevron-icon {
  transform: rotate(180deg);
}

.chevron-icon {
  width: 12px;
  /* Adjust size as needed */
  height: 7px;
  margin-left: 4px;
  /* Space between text and icon */
  margin-top: 2px;
  /* Adjust vertical alignment */
  transition: transform 0.3s ease;
  /* For rotation */
  stroke: var(--green03);
  /* Ensure the chevron uses the primary green color */
}

.dropdown2 {
  list-style: none;
  /* Remove bullets */
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  color: var(--green03);
  font-size: 16px;
  /* Adjusted to match other menu items */
  border-radius: 8px;
}

.dropdown2 a {
  padding: 10px 0;
  text-decoration: none;
  font-size: 16px;
  color: var(--green03);
}

.dropdown2 a:hover {
  background-color: #f1f1f1;
}
</style>